import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const getDefaultAuthenticatedRoute = (userType) => {
  switch (userType) {
    case 'doctor':
      return '/doctor/dashboard';
    case 'clinic':
      return '/clinic/dashboard';
    default:
      return '/profile';
  }
};

const ProtectedRoute = ({ children, allowedUserTypes }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (
    Array.isArray(allowedUserTypes) &&
    allowedUserTypes.length > 0 &&
    !allowedUserTypes.includes(user?.user_type)
  ) {
    return <Navigate to={getDefaultAuthenticatedRoute(user?.user_type)} replace />;
  }

  return children;
};

export default ProtectedRoute;
